import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Header from "../Components/Header";
import styles from "../styles/Blog.css";
import { Link } from "react-router-dom";
import { Grid2 } from "@mui/material";
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import Agendar from "../Components/Agendar";
import Footer from "../Components/Footer";

function BlogInterna() {
  const { id } = useParams(); 
  const [post, setPost] = useState(null);
  const [postList, setPostList] = useState([]);

  useEffect(() => {
    axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-posts?id=${id}`)
      .then((res) => {
        setPost(res.data);
      })
      .catch((err) => {
        console.error("Erro ao buscar post:", err);
      });
      
    axios.get("https://api.sigmasystems.com.br/api/odontoluzzi/get-posts?limit=6")
        .then((res) => {
        setPostList(res.data);
    }).catch((err) => {
        console.error("Erro ao buscar posts:", err);
        });
  }, [id]);



  return (
    <div className="container">
        <Header/>
        <div className="content">             
            <div className="blogContainer blogIntContainer">
                <div className="blogIntContent">
                    <div className="blogIntLeft">
                        <div className="blogIntHeader">
                            <div className="blogHeaderL from-left">
                                <CalendarTodayRoundedIcon sx={{color:'#B08E44'}}/>
                                <div className="data">{post?.dataFormatada}</div>
                                <div className="blogIntShare">Compartilhar</div>
                            </div>
                            
                            <div className="btnBack blogIntBack from-right" onClick={() => window.history.back()}>{'<< Voltar'}</div>
                        </div>
                        <div className="blogIntBody">
                            {post?.foto ? <img className="blogFoto from-left" src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/blog/${post.foto}`}/> : <img className="blogFoto from-left" src={"https://odontoluzzi.com.br/images/padrao/padraoBlog.png"}/>}
                            <div className="blogIntTitulo from-left" style={{ transitionDelay: '0.2s' }}><h2 style={{marginBottom:10}}>{post?.titulo}</h2></div>
                            <div className="blogIntText from-left" style={{ transitionDelay: '0.4s' }}>
                                <p>{post?.text}</p>
                            </div>
                            <div className="titleLine linePost from-left" style={{width:100, marginBottom:15}}/>
                            <div className="btnBack blogIntBack from-left" onClick={() => window.history.back()}>{'<< Voltar'}</div>
                        </div>

                    </div>
                    <div className="blogIntRight from-right">
                        <div className="blogIntListPosts">
                            <div className="blogListTitle from-right">Últimos conteúdos</div>
                            <Grid2 columns={{ xs:4, sm:8, md:12}} className='from-right' style={{ transitionDelay: '0.2s' }} container spacing={2} justifyContent={'left'}>
                                <Grid2 item>
                                    <Grid2 container justifyContent={'left'} spacing={3} width={'100%'} marginLeft={0}>
                                        {postList.map((post) => (
                                            <Link className="blogLink" to={`/Blog/${post.id}`}>
                                                <div className="blogIntCard">
                                                    <div className="blogIntCardData">
                                                        <CalendarTodayRoundedIcon sx={{color:'#FFF'}}/>
                                                        <div className="dataInt">{post?.dataFormatada}</div>
                                                    </div>
                                                    <h3 className="blogIntCardTitulo">{post.titulo}</h3>
                                                    <div className="blogIntCardText">
                                                        <p>{post.text.substring(0, 160)}...</p>
                                                    </div>
                                                    <div className="titleLine blogIntLinePost" style={{width:100, marginBottom:15}}/>
                                                </div>
                                            </Link>
                                        ))}
                                        
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </div>
                    </div>
                </div>
            </div>
            <Agendar/>
            <Footer/>
        </div>
    </div>
  );
}

export default BlogInterna;
